import { PortalState } from '../../../../redux/store'
import { LoginFormErrors } from './reducers'

export const getLoginForm = (state: PortalState): LoginFormErrors => (
  state.loginFormReducers.handleFormRequestsErrors.loginForm)
